import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  page: {},

  contentWrapper: {
    paddingTop: 20,
    paddingHorizontal: 40,
  },

  title: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 900,
    textAlign: 'left',
  },
  moderatorsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  moderatorItemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',

    border: '1px solid #ededed',
    borderRadius: 4,

    width: 73,
  },
  rowWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: 16,
  },

  speakerImagesWrapper: {
    width: '100%',
    height: 65,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  companyImagesWrapper: {
    backgroundColor: '#ffffff',
    width: '100%',
    height: 23,
  },

  speakerImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',

    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  companyLogo: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },

  moderatorDetailsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 5,

    width: '100%',
    height: 43,

    paddingTop: 5,
    paddingBottom: 7,
    paddingLeft: 5,
    paddingRight: 5,

    backgroundColor: '#27343D',
    borderTop: '2px solid #ededed',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
  speakerCompanyName: {
    color: '#ffffff',
    fontFamily: 'Lato',
    fontSize: 5,
    fontWeight: 400,
    textAlign: 'center',
  },
  speakerName: {
    color: '#ffffff',
    fontSize: 6,
    fontFamily: 'Lato',
    fontWeight: 900,
    textAlign: 'center',
  },
  websiteURLText: {
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 700,
  },

  speakingSection: {
    marginTop: 40,
    alignItems: 'center',
  },

  speakingTitle: {
    fontFamily: 'Lato',
    fontWeight: 900,
    fontSize: 14,
    color: '#27343d',
    textAlign: 'center',
  },

  speakingLine: {
    width: 60,
    height: 2,
    marginTop: 6,
    marginBottom: 12,
  },

  speakingDescription: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 400,
    lineHeight: 1.4,
    textAlign: 'center',

    paddingHorizontal: 10,
    marginBottom: 12,
  },

  speakingButton: {
    paddingVertical: 5,
    paddingHorizontal: 20,
    borderRadius: 2,

    marginBottom: 15,
  },

  speakingButtonWrapper: {
    color: '#ffffff',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 700,
  },

  speakingImagesRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },

  speakingImage: {
    width: '25%',
    height: 250,
    objectFit: 'cover',
  },
});
